var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M1.273 29.641a28.557 28.557 0 0 0 3.82 14.302l-4.06 14.824 15.17-3.978a28.604 28.604 0 0 0 13.675 3.481h.013c15.77 0 28.609-12.833 28.616-28.607.003-7.643-2.971-14.83-8.375-20.238C44.73 4.018 37.545 1.04 29.89 1.035c-15.773 0-28.61 12.833-28.617 28.606"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M.251 29.632a29.58 29.58 0 0 0 3.957 14.814L.002 59.803l15.715-4.12a29.629 29.629 0 0 0 14.165 3.607h.012c16.337 0 29.636-13.295 29.643-29.634.003-7.918-3.078-15.364-8.674-20.965C45.266 3.09 37.824.003 29.895 0 13.555 0 .258 13.293.252 29.632Zm9.358 14.04-.586-.93a24.565 24.565 0 0 1-3.767-13.108c.006-13.58 11.058-24.63 24.648-24.63 6.581.003 12.766 2.569 17.418 7.224 4.652 4.655 7.212 10.844 7.21 17.426-.006 13.58-11.058 24.63-24.637 24.63h-.01a24.609 24.609 0 0 1-12.54-3.434l-.9-.534-9.325 2.445 2.49-9.089Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.486 17.244c-.555-1.233-1.139-1.258-1.666-1.28-.433-.019-.927-.017-1.42-.017-.494 0-1.297.186-1.975.926-.679.742-2.593 2.533-2.593 6.177 0 3.645 2.655 7.166 3.025 7.66.37.494 5.124 8.212 12.652 11.18 6.257 2.468 7.53 1.977 8.888 1.853 1.358-.123 4.382-1.79 5-3.52.617-1.73.617-3.212.432-3.522-.185-.308-.68-.494-1.42-.864-.741-.37-4.383-2.162-5.061-2.41-.68-.246-1.173-.37-1.667.372-.494.74-1.912 2.408-2.345 2.902-.432.495-.864.557-1.604.187-.742-.372-3.127-1.153-5.957-3.676-2.202-1.964-3.688-4.388-4.12-5.13-.433-.74-.047-1.142.325-1.51.332-.332.74-.865 1.111-1.298.37-.432.493-.74.74-1.235.247-.494.123-.927-.061-1.297-.186-.37-1.625-4.034-2.284-5.498"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 29.77,
    x2: 29.77,
    y1: 58.767,
    y2: 1.035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 29.77,
    x2: 29.77,
    y1: 59.802,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h59.54v60H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosWhatsappIcon);
export default __webpack_public_path__ + "static/media/logos_whatsapp-icon.0901f9181dfc35ad4728a85eb2ddb7c6.svg";
export { ForwardRef as ReactComponent };